import React from 'react';
import styled from 'styled-components';

export default function CampaignInfoTab({
  activeTab,
  isShowReward,
  onTabClick
}) {
  return (
    <CampaignInfoTabBlock>
      {isShowReward && (
        <CampaignInfoTabItem className={activeTab === 'reward' && 'active'} onClick={() => onTabClick('reward')}>리워드</CampaignInfoTabItem>
      )}
      <CampaignInfoTabItem className={activeTab === 'todolist' && 'active'} onClick={() => onTabClick('todolist')} >인증기간</CampaignInfoTabItem>
      <CampaignInfoTabItem className={activeTab === 'sample_proof' && 'active'} onClick={() => onTabClick('sample_proof')}>인증방법</CampaignInfoTabItem>
      <CampaignInfoTabItem className={activeTab === 'challenge_info' && 'active'} onClick={() => onTabClick('challenge_info')} >챌린지소개</CampaignInfoTabItem>
    </CampaignInfoTabBlock>
  )
}

const CampaignInfoTabBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`;

const CampaignInfoTabItem = styled.div`
  border-radius: calc(100vw * (84 / 375));
  padding: calc(100vw * (11 / 375));
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (16 / 375));
  text-align: center;
  color: #989898;
  &.active
  {
    font-weight: 700;
    background: #4E4E4E;
    color: #fff;
  }
`;